// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/listini/:id',
    requestBody: null,
    response: '{"success":true,"data":"ImportListino"}'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/listini/:id/file-excel',
    requestBody: null,
    response: '(binary xlsx)'
  },
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/listini/:id/file-log',
    requestBody: null,
    response: '(binary txt)'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
